module.exports = __webpack_public_path__ + "img/user-information-security.2d45634c.svg";